import React, { useMemo } from 'react';
import { Pagination, Form } from 'react-bootstrap';

const CustomPagination = ({ page, limit, total, onPageChange, onLimitChange, ...props }) => {

  const totalPages = useMemo(() => Math.ceil(total / limit), [total, limit])

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      onPageChange(pageNumber);
    }
  };

  const renderPaginationItems = () => {
    const items = [];

    // Previous button
    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(page - 1)}
        disabled={page === 1}
      />
    );

    // Ellipses and page numbers
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === page}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      } else if (i === 2 || i === totalPages - 1) {
        items.push(<Pagination.Ellipsis key={`ellipsis-${i}`} />);
      }
    }

    // Next button
    items.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(page + 1)}
        disabled={page === totalPages}
      />
    );

    return items;
  };

  return (
    <div className='d-flex gap-2 justify-content-end' {...props}>
      <Form.Select style={{ maxWidth: 'max-content' }} value={limit} onChange={onLimitChange}>
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000000}>All</option>
      </Form.Select>
      <Pagination style={{ maxWidth: 'max-content', marginBottom: 0 }}>
        {renderPaginationItems()}
      </Pagination>
    </div>
  );
};

export default CustomPagination;